var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCcIconBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 5H4C3.17157 5 2.5 5.67157 2.5 6.5V17.5C2.5 18.3284 3.17157 19 4 19H21C21.8284 19 22.5 18.3284 22.5 17.5V6.5C22.5 5.67157 21.8284 5 21 5ZM3.5 9H21.5V12H3.5V9ZM21 18C21.2761 18 21.5 17.7761 21.5 17.5V13H3.5V17.5C3.5 17.7761 3.72386 18 4 18H21ZM3.5 8V6.5C3.5 6.22386 3.72386 6 4 6H21C21.2761 6 21.5 6.22386 21.5 6.5V8H3.5ZM4.5 15H8.5V14H4.5V15Z",
    fill: "#151515"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcIconBlack);
export default __webpack_public_path__ + "static/media/cc-icon-black.4c49d1e36d8ac3f940d66cc0f493baa4.svg";
export { ForwardRef as ReactComponent };